var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p-content-container',[_c('editor-toolbar'),(_vm.vrController.file)?_c('VRContainer',{attrs:{"editable":true}}):_c('p-upload-dropzone',{attrs:{"type":'vr',"image":require('../background_empty.svg')},on:{"file-uploaded":_vm.uploadFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }